import { Component, OnInit } from '@angular/core';
import { navItems } from '../nav.utils';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { BaseNavComponent } from '../base-nav.component';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageTempComponent } from '../../language-switcher/components/language-temp/language-temp.component';
import { MobileButtonWithSubitemsComponent } from '../../language-switcher/components/mobile-button-with-subitems/mobile-button-with-subitems.component';
import { PermissionEnum } from '@core/permissions/permission.enum';
import { PermittedDirective } from '@core/permissions/permitted.directive';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatDivider } from '@angular/material/divider';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'stx-mobile-nav',
  templateUrl: './mobile-nav.component.html',
  styleUrls: ['./mobile-nav.component.scss'],
  imports: [
    RouterLink,
    PermittedDirective,
    MatButton,
    MatTooltip,
    MatIcon,
    MatIconButton,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    RouterLinkActive,
    MobileButtonWithSubitemsComponent,
    MatDivider,
    LanguageTempComponent,
    TranslateModule,
    NgOptimizedImage
  ]
})
export class MobileNavComponent extends BaseNavComponent implements OnInit {
  navItems = navItems;
  hasActiveProfile: boolean;

  ngOnInit() {
    this.subSink.sink = this.currentUserService.user$.subscribe(user => {
      if (user) {
        this.getNavItems();
      }
    });
  }

  get canSeeEditSettingsRoute(): boolean {
    return this.authService.checkUserPermission(PermissionEnum.EDIT_USER_SETTINGS);
  }

  switchProfile(): void {
    this.router.navigateByUrl('/select-profile');
  }
}
